import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const ShopByMobileFilterBarButton = t0 => {
  const $ = _c(9);
  const {
    children,
    className,
    isOpen,
    onClick
  } = t0;
  const t1 = `text-sm font-bold items-center bg-white border-[1px] border-gray-light6 rounded-sm text-gray flex justify-center p-3 ml-1.5 ${className}`;
  let t2;
  if ($[0] !== isOpen || $[1] !== t1) {
    t2 = classNames(t1, {
      "!border-brand": isOpen
    });
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick) {
    t3 = () => onClick();
    $[3] = onClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t2 || $[7] !== t3) {
    t4 = <span role="button" tabIndex={0} className={t2} onClick={t3}>{children}</span>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default ShopByMobileFilterBarButton;
ShopByMobileFilterBarButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func
};